// Lights page — CRUD + on/off/toggle dispatch to Home Assistant.

(function ($) {
  'use strict';

  if ($('#light-tbody').length === 0) return;

  var BTN_PRIMARY = 'bg-orange-500 hover:bg-orange-600 text-white';
  var BTN_DANGER  = 'bg-red-500 hover:bg-red-600 text-white';

  function readForm() {
    return {
      name:      $('#light-name').val().trim(),
      entity_id: $('#light-entity_id').val().trim(),
    };
  }

  function patchRow($row, fields) {
    $.each(fields, function (key, value) {
      $row.find('.row-' + key).text(value);
    });
  }

  // Map state → pill + toggle switch classes.
  function paintState($row, state) {
    var $pill = $row.find('.light-state');
    var $text = $row.find('.light-state-text');
    $pill.removeClass(
      'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300 ' +
      'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300 ' +
      'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300'
    );
    if (state === 'on') {
      $pill.addClass('bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300');
      $text.text('On');
    } else if (state === 'off') {
      $pill.addClass('bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300');
      $text.text('Off');
    } else {
      $pill.addClass('bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300');
      $text.text('Unknown');
    }

    var $toggle = $row.find('.light-toggle-btn');
    var $knob = $row.find('.light-toggle-knob');
    $toggle.removeClass('bg-emerald-500 bg-slate-300 dark:bg-slate-600 bg-amber-400');
    $knob.removeClass('translate-x-0.5 translate-x-5');
    if (state === 'on') {
      $toggle.addClass('bg-emerald-500');
      $knob.addClass('translate-x-5');
    } else if (state === 'off') {
      $toggle.addClass('bg-slate-300 dark:bg-slate-600');
      $knob.addClass('translate-x-0.5');
    } else {
      $toggle.addClass('bg-amber-400');
      $knob.addClass('translate-x-0.5');
    }
  }

  // ---------- Live state polling ----------
  function refreshStates() {
    $.get('/api/lights/states/', function (resp) {
      if (!resp.ok) return;
      $.each(resp.states, function (id, state) {
        var $row = $('tr[data-id="' + id + '"]');
        if ($row.length) paintState($row, state);
      });
    });
  }
  refreshStates();
  setInterval(refreshStates, 10000);

  // ---------- Control ----------
  function control(action, $row) {
    var id = $row.data('id');
    $.post('/api/lights/' + id + '/' + action + '/')
      .done(function (r) {
        if (r.ok) {
          paintState($row, r.state);
          // HA's state cache lags Tuya by 1–2s. Re-poll to confirm the
          // predicted state actually took effect (or correct the UI).
          setTimeout(refreshStates, 2000);
        } else {
          Toast.show(r.error || 'Failed', 'error');
        }
      })
      .fail(function (xhr) {
        Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
      });
  }

  $(document).on('click', '.light-toggle-btn', function () { control('toggle', $(this).closest('tr')); });

  // ---------- Add ----------
  $(document).on('click', '.light-add-btn', function () {
    $.get('/api/lights/modal/add/', function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Add light', resp.html, { size: 'md' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Create',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/lights/add/', readForm())
              .done(function (r) {
                if (r.ok) {
                  $('#light-tbody').prepend(r.row_html);
                  Toast.show('Light added', 'success');
                  dlg.hide();
                  refreshStates();
                } else {
                  Toast.show(r.error || 'Failed', 'error');
                  lb.stop('Create');
                }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
                lb.stop('Create');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Edit ----------
  $(document).on('click', '.light-edit-btn', function () {
    var $row = $(this).closest('tr');
    var id = $row.data('id');
    $.get('/api/lights/modal/update/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Edit light', resp.html, { size: 'md' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Save',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/lights/' + id + '/update/', readForm())
              .done(function (r) {
                if (r.ok) {
                  patchRow($row, r.fields);
                  Toast.show('Light updated', 'success');
                  dlg.hide();
                } else {
                  Toast.show(r.error || 'Failed', 'error');
                  lb.stop('Save');
                }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
                lb.stop('Save');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Delete ----------
  $(document).on('click', '.light-delete-btn', function () {
    var $row = $(this).closest('tr');
    var id = $row.data('id');
    $.get('/api/lights/modal/delete/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Delete light', resp.html, { size: 'sm' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Delete',
          class: BTN_DANGER,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/lights/' + id + '/delete/')
              .done(function (r) {
                if (r.ok) {
                  $row.remove();
                  Toast.show('Light deleted', 'success');
                  dlg.hide();
                } else {
                  Toast.show(r.error || 'Failed', 'error');
                  lb.stop('Delete');
                }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
                lb.stop('Delete');
              });
          },
        },
      ]).show();
    });
  });

})(jQuery);
